import {Attachment} from '../message/Attachment';

export class AttachmentResult {
entities: Attachment[];
entity: Attachment;
thumb: Attachment;
}

